import React from "react";


const ColorScale = () => {
  const scales = [
    { label: "Least Transparent", range: "0.00% - 19.99%", color: "#d2232a",  },
    { label: "Slightly Transparent", range: "20.00% - 39.99%", color: "#f05860" },
    { label: "Partially Transparent", range: "40.00% - 59.99%", color: "#f8912a" },
    { label: "Moderately Transparent", range: "60.00% - 79.99%", color: "#fff200" },
    { label: "Significantly Transparent", range: "80.00% - 99.99%", color: "#59ba47" },
    { label: "Fully Transparent", range: "100%", color: "#41813c" },
  ];

  return (
    <div className="color-scale-container">
      {scales.map((item, index) => (
        <div key={index} className="color-scale-item">
          <span className="label">{item.label}</span>
          <span className="range" style={{ backgroundColor: item.color }}>
            {item.range}
          </span>
        </div>
      ))}
    </div>
  );
};

export default ColorScale;